export default {
  INIT: 0,
  PENDING: 1,
  ACTIVE: 2,
  REJECTED: 3,
  BLOCKED: 4,
  DELETED: 5,
}
